import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, default as firebaseApp } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Login from './pages/Login';
import Leads from './pages/Leads';
import Design from './pages/Design';
import Quote from './pages/Quote';
import Production from './pages/Production';
import Analytics from './pages/Analytics';
import Admin from './pages/Admin';
import Navigation from './components/Navigation';
import Logout from './components/Logout';

function Protected({ children }) {
  return auth.currentUser ? children : <Navigate to="/login" />;
}

export default function App() {
  const [user, setUser] = useState(undefined);
  useEffect(() => onAuthStateChanged(auth, setUser), []);
  if (user === undefined) return <div style={{padding:20}}>Loading...</div>;

  return (
    <Router>
      {user && (
        <>
          <Navigation />
          <Logout />
        </>
      )}
      <Routes>
        <Route path="/login" element={!user ? <Login/> : <Navigate to="/" />} />
        <Route path="/" element={<Protected><Leads/></Protected>} />
        <Route path="/design" element={<Protected><Design/></Protected>} />
        <Route path="/quote" element={<Protected><Quote/></Protected>} />
        <Route path="/production" element={<Protected><Production/></Protected>} />
        <Route path="/analytics" element={<Protected><Analytics/></Protected>} />
        <Route path="/admin" element={<Protected><Admin/></Protected>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
